// Type definition for widget keys (used in config and settings)
export type WidgetModelName =
  | 'recent_agreements'
  | 'recent_companies'
  | 'recent_contacts'
  | 'upcoming_birthdays'
  | 'cash_available_on_hand'
  | 'cash_reserves_on_hand'
  | 'credit_card_funds_available'
  | 'credit_card_debt'
  | 'financial_snapshot'
  | 'monthly_sales_summary'
  | 'annual_historical_sales'
  | 'recurring_revenue_variance'
  | 'inventory_below_minimum_stock'
  | 'inventory_asset_value'
  | 'upcoming_conferences_events'
  | 'quick_companies_overview'
  | 'expiring_domains_agreements'
  | 'top_competitors_snapshot'
  | 'geographic_agreement_map'
  | 'time_off_calendar'
  | 'agreement_close_conversion'
  | 'implementation_duration'
  | 'commission_dashboard'
  | 'mileage_tracking'
  | 'partner_payouts';

// Type for widget permission configuration
export type WidgetPermissionConfig = {
  name: string;
  model_name: WidgetModelName;
};

// Dashboard widgets permission configuration
export const dashboardWidgetsPermissionConfig: Record<WidgetModelName, WidgetPermissionConfig> = {
  recent_agreements: {
    name: 'Recent Agreements',
    model_name: 'recent_agreements', // !IMPORTANT: model_name is used to identify the widget in the database; Do not change it
  },
  recent_companies: {
    name: 'Recent Companies',
    model_name: 'recent_companies',
  },
  recent_contacts: {
    name: 'Recent Contacts',
    model_name: 'recent_contacts',
  },
  upcoming_birthdays: {
    name: 'Upcoming Birthdays',
    model_name: 'upcoming_birthdays',
  },
  cash_available_on_hand: {
    name: 'Cash Available on Hand',
    model_name: 'cash_available_on_hand',
  },
  cash_reserves_on_hand: {
    name: 'Cash Reserves on Hand',
    model_name: 'cash_reserves_on_hand',
  },
  credit_card_funds_available: {
    name: 'Credit Card Funds Available',
    model_name: 'credit_card_funds_available',
  },
  credit_card_debt: {
    name: 'Credit Card Debt',
    model_name: 'credit_card_debt',
  },
  financial_snapshot: {
    name: 'Financial Snapshots',
    model_name: 'financial_snapshot',
  },

  monthly_sales_summary: {
    name: 'Monthly Sales Summary 3-Year',
    model_name: 'monthly_sales_summary',
  },

  annual_historical_sales: {
    name: 'Annual Historical Sales',
    model_name: 'annual_historical_sales',
  },
  recurring_revenue_variance: {
    name: 'Recurring Revenue Variance',
    model_name: 'recurring_revenue_variance',
  },
  inventory_below_minimum_stock: {
    name: 'Inventory Below Minimum Stock',
    model_name: 'inventory_below_minimum_stock',
  },
  inventory_asset_value: {
    name: 'Inventory Asset Value',
    model_name: 'inventory_asset_value',
  },
  upcoming_conferences_events: {
    name: 'Upcoming Conferences & Events',
    model_name: 'upcoming_conferences_events',
  },
  quick_companies_overview: {
    name: 'Quick Companies Overview',
    model_name: 'quick_companies_overview',
  },
  expiring_domains_agreements: {
    name: 'Expiring Domains',
    model_name: 'expiring_domains_agreements',
  },
  top_competitors_snapshot: {
    name: 'Top 10 Competitors',
    model_name: 'top_competitors_snapshot',
  },
  geographic_agreement_map: {
    name: 'Geographic Agreement Map',
    model_name: 'geographic_agreement_map',
  },
  time_off_calendar: {
    name: 'Time Off Calendar',
    model_name: 'time_off_calendar',
  },
  agreement_close_conversion: {
    name: 'Agreement Close Conversion',
    model_name: 'agreement_close_conversion',
  },
  implementation_duration: {
    name: 'Implementation Duration',
    model_name: 'implementation_duration',
  },
  commission_dashboard: {
    name: 'Commission Dashboard',
    model_name: 'commission_dashboard',
  },
  mileage_tracking: {
    name: 'Mileage Tracking',
    model_name: 'mileage_tracking',
  },
  partner_payouts: {
    name: 'Partner Payouts',
    model_name: 'partner_payouts',
  },
};
